import React, { useEffect, useRef } from 'react';

import { mount } from 'redom';

import NativeTextLogo from './';

import './index.scss';

function NativeTextLogoReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeTextLogoReference = useRef(null);

  useEffect(function onLoad() {

    const nativeTextLogo = new NativeTextLogo(props);

    nativeTextLogoReference.current = nativeTextLogo;

    mount(wrapperMainReference.current, nativeTextLogoReference.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    nativeTextLogoReference.current.update(props);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'text-logo-native-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativeTextLogoReactWrapper;